import { connect } from 'react-redux';
import {
  doAddUserCommunities,
  doDeleteUserCommunities,
} from 'store/actionCreators/communities';
import {
  doAddCommunityUser,
  doDeleteCommunityUser,
} from 'store/actionCreators/currentCommunity';
import {
  doAddUserGroups,
  doDeleteGroupUser,
  doDeleteUserGroups,
} from 'store/actionCreators/currentGroup';
import { doAddMembersToGroup } from 'store/actionCreators/groups';

import MatrixList from './MatrixList';

const mapDispatchToProps = {
  deleteCommunityUser: doDeleteCommunityUser,
  addCommunityUsers: doAddCommunityUser,
  addUserCommunities: doAddUserCommunities,
  deleteUserCommunities: doDeleteUserCommunities,
  addMembersToGroup: doAddMembersToGroup,
  deleteGroupUser: doDeleteGroupUser,
  deleteUserGroups: doDeleteUserGroups,
  addUserGroups: doAddUserGroups,
};

const mapStateToProps = (state) => ({
  communities: state.communities.matrix,
  loadingMatrix: state.communities.loadingMatrix,
  authUser: state.auth.user,
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(MatrixList);
